import apiClient from '../apiClient';
import { normalizeEmployee } from '../transformers';

const formatDate = (date) => {
  if (!date) {
    return null;
  }
  if (typeof date === 'string') {
    return date;
  }
  return date.toISOString().split('T')[0];
};

const normalizeShift = (shift) => {
  if (!shift) {
    return null;
  }

  const rawEmployee = shift?.employee;
  const employeeRecord = normalizeEmployee(rawEmployee);
  const resolvedEmployeeId = employeeRecord?.id
    ?? (typeof shift?.employeeId === 'string' ? shift.employeeId : null)
    ?? (typeof rawEmployee === 'string' ? rawEmployee : null)
    ?? (typeof rawEmployee === 'object' && rawEmployee !== null
      ? typeof rawEmployee.id === 'string'
        ? rawEmployee.id
        : typeof rawEmployee._id === 'string'
          ? rawEmployee._id
          : null
      : null);
  const resolvedEmployeeName = employeeRecord?.name
    ?? (typeof shift?.employeeName === 'string' ? shift.employeeName : null)
    ?? (typeof rawEmployee === 'object' && rawEmployee !== null
      ? rawEmployee?.name ?? rawEmployee?.fullName ?? null
      : null)
    ?? '';

  return {
    id: shift?.id ?? shift?._id,
    employeeId: resolvedEmployeeId,
    employeeName: resolvedEmployeeName,
    role: shift?.role ?? employeeRecord?.role ?? '',
    date: shift?.date ?? formatDate(shift?.startDate),
    startTime: shift?.startTime ?? '09:00',
    endTime: shift?.endTime ?? '17:00',
    locationId: shift?.locationId ?? 'downtown',
    status: shift?.status ?? 'scheduled',
    notes: shift?.notes ?? '',
    hourlyRate: typeof shift?.hourlyRate === 'number' ? shift.hourlyRate : 0,
    employee: employeeRecord,
    raw: shift,
  };
};

export const fetchShifts = async ({ from, to, locationId, employeeId } = {}) => {
  const params = new URLSearchParams();
  if (from) {
    params.append('from', from);
  }
  if (to) {
    params.append('to', to);
  }
  if (locationId) {
    params.append('locationId', locationId);
  }
  if (employeeId) {
    params.append('employeeId', employeeId);
  }

  const query = params.toString();
  const response = await apiClient.get(`/shifts${query ? `?${query}` : ''}`);
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map(normalizeShift).filter(Boolean);
};

export const createShift = async (payload) => {
  const response = await apiClient.post('/shifts', payload);
  return normalizeShift(response?.data);
};

export const updateShift = async (id, payload) => {
  const response = await apiClient.patch(`/shifts/${id}`, payload);
  return normalizeShift(response?.data);
};

export const deleteShift = async (id) => {
  if (!id) {
    throw new Error('A shift id is required to delete a shift.');
  }
  await apiClient.delete(`/shifts/${id}`);
  return true;
};

export default {
  fetchShifts,
  createShift,
  updateShift,
  deleteShift,
};
